import { JSONInterface } from './JsonInterface';

export type YesNo = 'yes' | 'no';
export type PricingMethod = 'Per User' | 'Per Transaction';
export type PaymentPlan = 'monthly' | 'annual';

export interface PaymentPlanInfo {
  plan: string;
  pricingMethod: PricingMethod;
  paymentSchedule: string;
  monthsSubscribed: string;
  validFrom: string;
  validTo: string;
  active: YesNo;
  futurePackage: string;
  futurePricingPlan: string;
  futurePaymentSchedule: string;
  futureSubscriptionMonths: string;
  futureLicenseValidFrom: string;
  futureLicenseValidTo: string;
  futureMaxUsers: string;
  chargePerUploadCustom: string;
  chargePerUserCustom: string;
  chargePerUploadLight: string;
  chargePerUserLight: string;
  chargePerUploadPro: string;
  chargePerUserPro: string;
  officeUsers: string;
  payingCustomer: YesNo;
  autoRenew: 'true' | '';
  activeUsers: number;
  maxUsers: number;
  maxTransactions: number;
  totalTransactions: number;
  transcriptionBudget: number;
  transcriptionUsage: number;
  transcriptionBudgetUnits: number;
  transcriptionUsageUnits: number;
  transactionPrices: TransactionPrices;
  currency: CURRENCY;
  paymentPlan: PaymentPlan;
  aiCredits: number;
  aiUsage: number;
}

export interface PaymentPlanInfoInterface {
  paymentPlanInfo: PaymentPlanInfo | null;
  card: JSONInterface;
}

export interface PlanDetails {
  max_users?: string;
  max_transactions?: string;
  license_valid_from?: string;
  license_valid_until?: string;
  no_of_office_users?: string;
  pricing_plan?: string;
  autoRenew?: boolean;
  additional_users?: number;
  subscriptionMonths?: number;
  oneTimePayment?: string;
  transcription?: number;
  monthlyLicences?: number;
  futureMaxUsers?: number;
  package?: string;
  aiCredits?: number;
}

export interface PackageDetails extends PlanDetails {
  package: 'Pro' | 'Light' | 'Custom';
  action: string;
}

interface PaymentDetails {
  amount: number;
  taxAmount: number;
}

export interface PaymentRegistration extends Pick<Payment, 'package' | 'payment' | 'plan'> {
  vatNo: string;
}

export interface Payment {
  token: string;
  nonce?: string;
  plan?: PlanDetails;
  package?: PackageDetails;
  payment?: PaymentDetails;
}

export type PaymentType = 'NEW' | 'RENEW' | 'MORE_TRANSACTIONS' | 'MORE_USERS' | 'ONE_TIME_PAYMENT';

export interface TransactionPrice {
  transactionCount: number;
  price: number;
}

export type TransactionPrices = TransactionPrice[];

export enum CURRENCY {
  USD = 'USD',
  EUR = 'EUR'
}

export const INITIAL_PAYMENT_PLAN_INFO: Partial<PaymentPlanInfo> = {
  currency: CURRENCY.USD,
  paymentPlan: 'annual'
};
